var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        visible: _vm.open,
        title: "Dataset provenance",
        size: "lg",
        scrollable: "",
      },
      on: {
        hidden: function ($event) {
          return _vm.$emit("close")
        },
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "b-button",
                {
                  attrs: { size: "sm", variant: "secondary" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [_vm._v("Close")]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("p", { staticClass: "small text-muted mb-3" }, [
        _vm._v(
          " Open CFDE Data Resource Center pages for gene sets in your current selection. "
        ),
      ]),
      !_vm.geneSetIds.length
        ? _c("div", { staticClass: "text-muted small" }, [
            _vm._v(
              " Select one or more gene sets to find dataset provenance. "
            ),
          ])
        : _c(
            "div",
            { staticClass: "mq-prov-list" },
            _vm._l(_vm.items, function (item) {
              return _c(
                "div",
                {
                  key: item.geneSetId,
                  staticClass: "mq-prov-item border rounded p-2 mb-2",
                },
                [
                  _c("div", { staticClass: "font-weight-bold small mb-1" }, [
                    _vm._v(_vm._s(item.geneSetId)),
                  ]),
                  item.status === "loading"
                    ? _c("div", { staticClass: "small text-muted" }, [
                        _vm._v("Loading provenance…"),
                      ])
                    : item.status === "error"
                    ? _c("div", { staticClass: "small text-danger" }, [
                        _vm._v("Could not load provenance."),
                      ])
                    : item.status === "empty"
                    ? _c("div", { staticClass: "small text-muted" }, [
                        _vm._v("No DRC links found for this gene set."),
                      ])
                    : _c(
                        "div",
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "small text-uppercase text-muted mb-1",
                            },
                            [_vm._v("Open or download")]
                          ),
                          _vm._l(item.nodes, function (node, idx) {
                            return _c(
                              "a",
                              {
                                key: item.geneSetId + "-" + idx + "-" + node.id,
                                staticClass:
                                  "fbr-provenance-menu-link d-block px-2 py-1 small text-dark text-decoration-none",
                                attrs: {
                                  href: node.dcc_url,
                                  target: "_blank",
                                  rel: "noopener noreferrer",
                                },
                              },
                              [_vm._v(_vm._s(node.id))]
                            )
                          }),
                        ],
                        2
                      ),
                ]
              )
            }),
            0
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }